import * as React from 'react';

import { compose } from 'recompose';

import Retracked from 'js/app/retracked';

import ConsumerHeaderFooterWrapper from 'bundles/unified-description-page-common/pages/consumer/ConsumerHeaderFooterWrapper';
import ConsumerPageGuard from 'bundles/unified-description-page-common/pages/consumer/ConsumerPageGuard';
import ConsumerProjectPageDirector from 'bundles/unified-description-page-common/pages/consumer/project/ConsumerProjectPageDirector';
import ConsumerProjectPageDataProvider from 'bundles/unified-description-page-common/providers/consumer/pages/ConsumerProjectPageDataProvider';

const ConsumerProjectPageRoot = () => {
  return (
    <ConsumerProjectPageDataProvider>
      <ConsumerHeaderFooterWrapper>
        <ConsumerPageGuard>
          <ConsumerProjectPageDirector />
        </ConsumerPageGuard>
      </ConsumerHeaderFooterWrapper>
    </ConsumerProjectPageDataProvider>
  );
};

export default compose(
  Retracked.createTrackedContainer(() => ({
    namespace: {
      app: 'unified_description_page',
      page: 'consumer_project_page',
    },
  }))
)(ConsumerProjectPageRoot);
